import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import "../ComponentCss/PaymentReturn.css";

const PaymentReturn = () => {
    // const { id: razorpayOrderId = "" } = useParams();
    const params = useParams();
    const location = useLocation();
    const razorpayOrderId = params?.id || "";
    const isCashOnDeliveryReturn = razorpayOrderId === "cash_on_delivery";
    const [paymentResponse, setPaymentResponse] = useState(null);
    const [showLoader, setShowLoader] = useState(true);


    const updatePaymentStatus = useCallback(async () => {
        try {
            const response = await post(API_URL.statusupdate, {
                order_id: razorpayOrderId,
            });

            if (response?.status) {
                setPaymentResponse(response?.data || null);
            } else {
                setPaymentResponse(null);
            }
        } catch (error) {
            setPaymentResponse(null);
        } finally {
            setShowLoader(false);
        }
    }, [razorpayOrderId]);

    useEffect(() => {
        if (isCashOnDeliveryReturn) {
            setPaymentResponse({
                order_id: location?.state?.orderId || "",
                payment_type: "cash_on_delivery",
                method: "Cash on Delivery",
                isSuccess: 2,
            });
            setShowLoader(false);
            return;
        }

        if (!razorpayOrderId) {
            setShowLoader(false);
            return;
        }

        updatePaymentStatus();
    }, [isCashOnDeliveryReturn, location?.state?.orderId, razorpayOrderId, updatePaymentStatus]);

    const paymentState = useMemo(() => {
        const res = paymentResponse || {};

        const paymentType = String(res.payment_type || "").toLowerCase();
        const isSuccess = Number(res.isSuccess);

        const paymentStatus = String(res?.data?.payment_status || "").toLowerCase();
        const orderStatus = String(res.order_status || "").toLowerCase();

        if (isCashOnDeliveryReturn) {
            return "success";
        }

        // ✅ COD ALWAYS SUCCESS
        if (paymentType === "cash_on_delivery" || isSuccess === 2) {
            return "success";
        }

        // ✅ ONLINE SUCCESS
        if (paymentStatus === "success" || orderStatus === "success") {
            return "success";
        }

        // ❌ FAILURE
        if (paymentStatus === "failed" || orderStatus === "failed") {
            return "failed";
        }

        // 🔥 IMPORTANT: unpaid is NOT failure for COD or order placed
        if (paymentStatus === "unpaid" && paymentType === "cash_on_delivery") {
            return "success";
        }

        return "failed";
    }, [isCashOnDeliveryReturn, paymentResponse]);

    const isCashOnDeliverySuccess = isCashOnDeliveryReturn ||
        paymentResponse?.payment_type === "cash_on_delivery" ||
        Number(paymentResponse?.isSuccess) === 2;

    const amountLabel = useMemo(() => {
        const amount = Number(paymentResponse?.amount || 0);
        return amount > 0 ? amount.toFixed(2) : null;
    }, [paymentResponse]);

    return (
        <div className="payment-return-page">
            {showLoader ? (
                <div className="loader">
                    <div className="spinner"></div>
                </div>
            ) : (
                <>
                    <div className="container payment-return-container">
                        {paymentState === "success" ? (
                            <div className="payment-return-body">
                                <div className="payment_successful text-center">
                                    <img src="../images/gif.gif" alt="Payment success" className="success-gif" />

                                    <h1>
                                        {isCashOnDeliverySuccess
                                            ? "Order Placed Successfully!"
                                            : "Payment Success!"
                                        }
                                    </h1>

                                    <p>Thank you! Your order has been placed successfully.</p>

                                    {paymentResponse?.payment_id && (
                                        <p>Payment ID: {paymentResponse.payment_id}</p>
                                    )}

                                    {amountLabel && (
                                        <p>Amount Paid: Rs. {amountLabel}</p>
                                    )}

                                    {paymentResponse?.method && (
                                        <p>Payment Method: {paymentResponse.method}</p>
                                    )}

                                    <Link to="/" className="button web_buttons">Go to Homepage</Link>
                                </div>
                            </div>
                        ) : (
                            <div className="payment-return-body">
                                <div className="payment_successful payment_failed text-center">
                                    <img src="./images/failed.gif" alt="Payment failed" className="success-gif" />

                                    <h1>Payment Failed!</h1>

                                    <p>We couldn't process your payment. Please try again.</p>

                                    {paymentResponse?.payment_id && (
                                        <p>Payment ID: {paymentResponse.payment_id}</p>
                                    )}

                                    {paymentResponse?.razorpay_order_id && (
                                        <p>Order ID: {paymentResponse.razorpay_order_id}</p>
                                    )}

                                    <Link to="/" className="button web_buttons">Go to Homepage</Link>
                                </div>
                            </div>
                        )}


                    </div>
                </>
            )}
        </div>
    );
};

export default PaymentReturn;
